import { cva, VariantProps } from "cva";
import React from "react";

import { IconButton } from "./IconButton";
import * as styles from "./IconButton.module.css";
import { IconButtonExternalLink } from "./IconButtonExternalLink";
import { IconButtonLink } from "./IconButtonLink";

export const variants = cva({
  base: styles.base,
  variants: {
    variant: {
      solid: styles.solid,
      filled: styles.filled,
      lighted: styles.lighted,
      subtle: styles.subtle,
    },
    color: {
      key: styles.key,
      weak: styles.weak,
    },
    shadow: {
      true: styles.shadow,
    },
    size: {
      s: styles.s,
    },
  },
  defaultVariants: {
    variant: "solid",
  },
});

export type IconButtonProps = VariantProps<typeof variants> &
  React.ButtonHTMLAttributes<HTMLButtonElement> & {
    disabled?: boolean;
    children?: React.ReactNode;
    number?: number;
    text?: string;
  };

export { IconButton, IconButtonExternalLink, IconButtonLink };
